import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import servicingService from "../services/servicing.service";
import { Servicingvalidationschema } from "../components/Validation";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, Link } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
import authsService from "../services/auths.service";
const Airconservicing = () => {
  const userinfo = authsService.userinfo();

  const ref = useRef();
  let navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState("");
  const [eventname, setEventname] = useState("create");

  const [servicings, setServicings] = useState([]);
  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [filter, setFilter] = useState("");
  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "ID", value: "" },
    { label: "servicing name", value: "servicing_name" },
    { label: "Price", value: "servicing_price" },
    { label: "Status", value: "" },
    { label: "Created", value: "createdAt" },
    { label: "actions", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };
  //form initial value
  const formik = useFormik({
    initialValues: {
      servicing_id: "",
      servicing_name: "",
      servicing_price: 0,
      servicing_status: "active",
      user_name:userinfo.user_name,

    },
    validationSchema: Servicingvalidationschema,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      /* resetForm({ values: "" }); */
    },
  });
  //use effects
  useEffect(() => {
    getallServicing();
  }, []);
  useLayoutEffect(() => {
    getallServicing();
  }, [page, limit, filter, search, between, sort]);

  //current event
  const servicingEvent = (eventname, value) => {
    if (value != "") {
      getServicing(value);
      setEventname(eventname);
    }
    setEventname(eventname);
    formik.resetForm();
  };
  //get allservicing
  const getallServicing = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await servicingService
      .getallServicing(data)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          setServicings(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          console.log(res.data);
        } else {
          setIsLoaded(false);
          setServicings(null);
          ref.current.toastlog(res.data.status, res.data.message);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort == value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort == value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
        " , " +
        format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  //between
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  //get servicing
  const getServicing = (value) => {
    setIsLoaded(true);
    servicingService
      .getServicing(value)
      .then((res) => {
        if (res.data.result) {
          console.log(res.data);
          setIsLoaded(false);
          let data = res.data.result;
          formik.setValues({
            servicing_id: data.servicing_id,
            servicing_name: data.servicing_name,
            servicing_price: data.servicing_price,
            servicing_status: data.servicing_status,
            user_name:userinfo.user_name,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //create servicing
  const createServicing = () => {
    servicingService
      .createServicing(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create");
          getallServicing();
          formik.resetForm();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };

  //update servicing
  const updateServicing = (value) => {
    console.log(JSON.stringify(formik.values, null, 2));
    servicingService
      .updateServicing(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("view");
          getallServicing();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //delete servicing
  const deleteServicing = (value) => {
    console.log(value);
    servicingService
      .deleteServicing(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create", "");
          formik.resetForm();
          getallServicing();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  const selectedcolor = (value) => {
    if (value === "active") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "inactive") {
      return "badge rounded-pill bg-danger";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  // Call servicing clicks to request another page.
  if (ismessage === "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  return (
    <div className="">
      <div className="">
        {/*  loader and error handler */}
        {<Toastmessage ref={ref} />}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      <div className="servicing-container">
        {/* servicing form */}
        <div className="card border-0 mb-2">
          <div className="card-body ">
            <div className="d-flex">
              <h5 className="card-title p-0 m-0 me-auto">Servicing</h5>
              {eventname == "create" ? (
                <></>
              ) : (
                <div className="d-none">
                  <div className="dropdown ">
                    <a
                      className="btn  btn-link"
                      href="#"
                      role="button"
                      id="servicingeventdropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="servicingeventdropdownMenuLink"
                    >
                      <li>
                        <a
                          onClick={() => {
                            servicingEvent("edit", "");
                          }}
                          className="dropdown-item"
                        >
                          Edit
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() => servicingEvent("delete", "")}
                          className="dropdown-item"
                        >
                          Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-md-3">
                  <label htmlFor="servicing_id" className="form-label">
                    ID
                  </label>
                  <div className="input-group col-md-6">
                    <input
                      className="form-control"
                      placeholder="Enter Servicing ID"
                      id="servicing_id"
                      type="text"
                      disabled={
                        eventname == "view"
                          ? true
                          : eventname == "delete"
                          ? true
                          : false
                      }
                      {...formik.getFieldProps("servicing_id")}
                    />
                  </div>
                  <div>
                    {formik.touched.servicing_id && formik.errors.servicing_id ? (
                      <div className="error">{formik.errors.servicing_id}</div>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-4 ">
                  <label htmlFor="servicing_name" className="form-label">
                    Name
                  </label>
                  <div className="input-group">
                    <input
                      className="form-control"
                      placeholder="Enter Servicingname"
                      id="servicing_name"
                      type="text"
                      disabled={
                        eventname == "view"
                          ? true
                          : eventname == "delete"
                          ? true
                          : false
                      }
                      {...formik.getFieldProps("servicing_name")}
                    />
                  </div>
                  <div>
                    {formik.touched.servicing_name && formik.errors.servicing_name ? (
                      <div className="error">{formik.errors.servicing_name}</div>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-2">
                  <label htmlFor="servicing_price" className="form-label">
                    price
                  </label>
                  <div className="input-group">
                    <input
                      className="form-control"
                      placeholder="Enter price"
                      id="servicing_price"
                      type="number"
                      disabled={
                        eventname == "view"
                          ? true
                          : eventname == "delete"
                          ? true
                          : false
                      }
                      {...formik.getFieldProps("servicing_price")}
                    />
                  </div>
                  <div>
                    {formik.touched.servicing_price && formik.errors.servicing_price ? (
                      <div className="error">{formik.errors.servicing_price}</div>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="servicing_status" className="form-label">
                    status
                  </label>
                  <div className="input-group col-md-6">
                    <select
                      id="servicing_status"
                      {...formik.getFieldProps("servicing_status")}
                      className="form-select"
                      aria-label="servicing_status"
                      disabled={
                        eventname == "view"
                          ? true
                          : eventname == "delete"
                          ? true
                          : false
                      }
                    >
                      <option value="" disabled>
                        Select status
                      </option>
                      <option value="pending">Pending</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                  <div>
                    {formik.touched.servicing_status && formik.errors.servicing_status ? (
                      <div className="error">{formik.errors.servicing_status}</div>
                    ) : null}
                  </div>
                </div>
                {/* servicing event buttons */}
                <div className="col-md-12 pt-2 pb-2">
                  {eventname === "create" ? (
                    <>
                      <button
                        disabled={!formik.isValid || !formik.dirty}
                        onClick={() => createServicing()}
                        className="btn btn-primary me-2"
                      >
                        Create
                      </button>
                      <button
                        disabled={!formik.dirty}
                        onClick={formik.handleReset}
                        className="btn btn-secondary"
                      >
                        Clear
                      </button>
                    </>
                  ) : eventname === "edit" ? (
                    <>
                      <button
                        onClick={() => updateServicing()}
                        className="btn btn-primary me-2"
                      >
                        Update
                      </button>
                      <a
                        onClick={() => {
                          servicingEvent("create", "");
                          formik.handleReset();
                        }}
                        className="btn btn-secondary"
                      >
                        Cancel
                      </a>
                    </>
                  ) : eventname === "delete" ? (
                    <>
                      <button
                        onClick={() => deleteServicing(formik.values.servicing_id)}
                        className="btn btn-danger me-2 "
                      >
                        Delete
                      </button>
                      <a
                        onClick={() => {
                          servicingEvent("create", "");
                          formik.handleReset();
                        }}
                        className="btn btn-secondary"
                      >
                        Cancel
                      </a>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          servicingEvent("create", "");
                          formik.handleReset();
                        }}
                        className="btn btn-primary"
                      >
                        Close
                      </button>
                    </>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* tebale header part search,filter,sort */}
        <div className="d-md-flex  mb-2 ">
          {/* create servicing */}
          {/*  <div className="m-1">
            <button
              onClick={() => {
                setEventname("create", "");
                formik.handleReset();
              }}
              type="submit"
              className="btn btn-primary  w-100"
            >
              <i className="fa fa-plus-circle"></i> New
            </button>
          </div> */}
          {/* filter status*/}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Filter
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Servicing Status</li>
              {filterarray.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterfn(filterdata.status_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.status_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/* search */}
          <div className=" m-1">
            <input
              className="form-control"
              onChange={searchfn}
              placeholder="search"
              type="search"
            ></input>
          </div>
          {/*  date range  */}
          <div className="m-1 ms-auto">
            <div className="btn-group" role="group">
              {between ? (
                <button
                  type="button"
                  className="btn bg-white border me-1 "
                  onClick={resetbetweenfn}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn bg-white border dropdown-toggle"
                id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="fa fa-calendar" aria-hidden="true"></i> {between}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuClickableInside"
              >
                <li className="">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={(date) => betweenfn(date)}
                  />
                </li>
                <li className="text-end">
                  <a onClick={resetbetweenfn} className="btn">
                    Reset
                  </a>
                  {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                </li>
              </ul>
            </div>
          </div>
          {/* between */}
        </div>
        {/* table section*/}
        <div className="table-responsive card bg-white border-0 mb-2">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                {tableHeaders.map((data, index) => (
                  <th key={index} scope="col">
                    {data.label}
                    {/* table sort */}
                    {data.value != "" ? (
                      <a
                        onClick={() => sortfn(data.value)}
                        className="btn btn-sm"
                      >
                        <span
                          className={
                            sort === data.value + " asc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          <i className="fa fa-long-arrow-up"></i>
                        </span>
                        <span
                          className={
                            sort === data.value + " desc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          <i className="fa fa-long-arrow-down"></i>
                        </span>
                      </a>
                    ) : (
                      <></>
                    )}
                  </th>
                ))}
                {/* <th scope="col">#</th>
                <th scope="col">servicing name</th>
                <th scope="col">Status</th>
                <th style={{ width: 100 }} scope="col">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {/* table data */}
              {servicings ? (
                <>
                  {servicings.map((data, index) => (
                    <tr key={index}>
                      <td>{data.servicing_id}</td>
                      <td>{data.servicing_name}</td>
                      <td>{data.servicing_price}</td>
                      <td>
                        <span className={selectedcolor(data.servicing_status)}>
                          {data.servicing_status}
                        </span>
                      </td>
                      <td>{format(new Date(data.createdAt), "PPpp")}</td>
                      <td className="p-1 m-0">
                        <button
                          onClick={() => servicingEvent("view", data.servicing_id)}
                          className="btn btn-light me-2 "
                        >
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        </button>
                        <button
                          onClick={() => servicingEvent("edit", data.servicing_id)}
                          className="btn btn-light me-2 "
                        >
                          <i
                            className="fa fa-pencil-square"
                            aria-hidden="true"
                          ></i>
                        </button>
                        <button
                          onClick={() => servicingEvent("delete", data.servicing_id)}
                          className="btn btn-light me-2 "
                        >
                          <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                  <div className="text-center p-3">0 data found</div>
                  </td>
                </tr>
              )}
            </tbody>
            <caption className="">
              <div className="d-flex">
                <div className="flex-fill"></div>
                <div className="p-1 "> Items per page </div>
                <div>
                  {" "}
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(e.target.value);
                      setPage(1);
                    }}
                    className="form-select form-select-sm"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                  </select>
                </div>
                <div className="p-1 me-4">
                  {page * limit - limit}-{page * limit} of {resultCount}
                </div>
                <ReactPaginate
                  previousLabel="< Prev"
                  nextLabel="Next >"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pagecount}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={3}
                  onPageChange={paginationfn}
                  containerClassName="pagination"
                  activeClassName="actives"
                  disabledLinkClassName="text-secondary"
                  forcePage={page - 1}
                />
              </div>
            </caption>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Airconservicing;
